module.exports = __webpack_public_path__ + "media/images/accordion-navy-5ce9e780b9cc2b4f3b1220222b05355a.svg";